import { axiosClient } from "./axiosClient";

export type PlatformSettings = {
  app_section_enabled: boolean;
  app_store_url: string | null;
  google_play_url: string | null;
  app_hero_ios_url: string | null;
  app_hero_android_url: string | null;
  app_mockup_url: string | null;
  node_repo_url: string | null;
};

// Publiczne ustawienia platformy (m.in. sekcja „Pobierz aplikację" na stronie głównej).
export const getPlatformSettings = () => axiosClient.get<PlatformSettings>("settings");

// Weryfikacja hasła odblokowującego notatki + tryb prezentera (hasło z panelu /admin).
export const unlockPresentation = (password: string) =>
  axiosClient.post<{ unlocked: boolean }>("settings/unlock-prezentacja", { password });
